import { countries } from 'app/data/countries';

export const COUNTRY_OPTIONS = countries.map((c) => ({ label: c.name, value: c.code }));

export const TRACKS = [
  {
    value: 'freelancer',
    label: 'Freelancer',
    description: 'You operate independently, onboarding and managing clients on your own.'
  },
  {
    value: 'business',
    label: 'Business',
    description: 'You represent a registered business with a team.'
  }
];

export const BUSINESS_TYPES = [
  { label: 'Public Limited Company (PLC)', value: 'plc' },
  { label: 'Sole Proprietorship', value: 'sole_proprietorship' },
  { label: 'Partnership', value: 'partnership' }
];

/** Verification attempt caps. */
export const PHONE_MAX_ATTEMPTS = 5;
export const BVN_MAX_ATTEMPTS = 3;
export const CAC_MAX_ATTEMPTS = 3;
export const NIN_MAX_ATTEMPTS = 3;
